import { io } from 'socket.io-client'
import { baseUrl } from 'features/constants'

let socket = null
let activeAccount = ''
let activeToken = ''
const joinedChurchThreads = new Set()

const acknowledge = (event, payload) => new Promise((resolve) => {
  if (!socket?.connected) {
    resolve({ success: false, error: { code: 'SOCKET_DISCONNECTED' } })
    return
  }
  socket.timeout(5000).emit(event, payload, (error, response) => {
    resolve(error ? { success: false, error: { code: 'ACK_TIMEOUT' } } : (response || { success: false }))
  })
})

const rejoin = () => joinedChurchThreads.forEach((churchId) => {
  acknowledge('churchThread:join', { churchId })
})

export const socketService = {
  connect({ token, accountId, isOrganization }) {
    const account = `${isOrganization ? 'church' : 'user'}:${accountId}`
    if (!token || !accountId) return null
    if (socket && activeToken === token && activeAccount === account) {
      if (!socket.connected) socket.connect()
      return socket
    }
    this.disconnect()
    activeToken = token
    activeAccount = account
    socket = io(baseUrl.replace(/\/$/, ''), { auth: { token }, reconnection: true })
    socket.on('connect', rejoin)
    return socket
  },

  disconnect() {
    socket?.removeAllListeners()
    socket?.disconnect()
    socket = null
    activeToken = ''
    activeAccount = ''
    joinedChurchThreads.clear()
  },

  joinChurchThread(churchId) {
    const id = String(churchId || '')
    if (!id) return Promise.resolve({ success: false })
    joinedChurchThreads.add(id)
    return acknowledge('churchThread:join', { churchId: id })
  },

  leaveChurchThread(churchId) {
    const id = String(churchId || '')
    joinedChurchThreads.delete(id)
    return acknowledge('churchThread:leave', { churchId: id })
  },

  on(event, handler) {
    if (!socket) return () => undefined
    const actualEvent = event === 'reconnect' ? 'connect' : event
    socket.on(actualEvent, handler)
    return () => socket?.off(actualEvent, handler)
  },
}
